import React, { Component } from 'react';
import { FiCheck } from 'react-icons/fi';
import Button from 'core/components/Button';

class SaveDeckButton extends Component {
  handleSave = () => {
    const { board, onSave } = this.props;

    board.save().then(() => {
      if (onSave) {
        onSave({ board });
      }
    });
  };

  render() {
    const { board, onSave, ...rest } = this.props;
    return <Button icon={FiCheck} intent="primary" text="Save Changes" onClick={() => this.handleSave()} {...rest} />;
  }
}

export default SaveDeckButton;
